import { isNil } from 'lodash/fp';
import { PersonalDetailGetModelType } from 'widgets/PersonalDetails/PersonalDetails.types';
import { formatDate } from 'utils/datetime';

export const getModel = (outputData, getFormattedDate): PersonalDetailGetModelType => {
    const personalInformation = outputData?.details?.personalInformation;
    const communicationMethods = outputData?.details?.communicationMethods;
    const loadedOccupation = personalInformation?.occupation;
    const affiliatedPensionFund = !isNil(outputData?.details?.personalInformation?.affiliatedPensionFund) ? String(outputData?.details?.personalInformation?.affiliatedPensionFund) : undefined;
    const occupationValue = () => (loadedOccupation ? String(loadedOccupation) : undefined);

    return {
        firstName: personalInformation?.firstName,
        lastName: personalInformation?.lastName,
        clientName: personalInformation?.displayName,
        dateOfBirth: personalInformation?.dateOfBirth && typeof getFormattedDate === 'function' && getFormattedDate(personalInformation?.dateOfBirth),
        clientAge: personalInformation?.dateOfBirth && Number(formatDate(new Date(), 'YYYY')) - Number(formatDate(new Date(personalInformation?.dateOfBirth), 'YYYY')),
        gender: personalInformation?.gender,
        street: personalInformation?.primaryAddressStreet,
        PLZ: personalInformation?.primaryAddressPostalCode,
        ORT: personalInformation?.primaryAddressCity,
        countryOfNationality: String(personalInformation?.identification?.[0]?.countryOfNationality),
        countryOfResidence: String(personalInformation?.primaryAddressCountry),
        countryOfBirth: personalInformation?.countryOfBirth ? String(personalInformation?.countryOfBirth) : undefined,
        primaryEmail: personalInformation?.primaryEmail,
        primaryPhoneNumber: personalInformation?.primaryPhoneNumber,
        telephoneNumber: communicationMethods?.secondaryPhoneNumber,
        avhNumber: personalInformation?.ahvNo,
        clientId: outputData?.id,
        affiliatedPensionFund,
        occupation: occupationValue(),
        member: personalInformation?.member || false,
        destinedLife: personalInformation?.destinedLife || false,
        zurichMA: personalInformation?.zurichMA || false,
        employmentContinuation: personalInformation?.employmentContinuation,
        employmentContinuationDate: personalInformation?.employmentContinuationDate,
        mailingAddress: {
            country: communicationMethods?.mailRecipient?.mailRecipientAddressCountry,
            street: communicationMethods?.mailRecipient?.mailRecipientAddressLine3,
            zip: communicationMethods?.mailRecipient?.mailRecipientAddressLine4,
            city: communicationMethods?.mailRecipient?.mailRecipientAddressLine5,
        },
    };
};
